import { LOG_PREFIX } from '../resources';

// Show a popup after 10 article views, or after the user clicks bookmarking for the first time as a logged in user.

// After how many views a popup should appear
const VIEW_LIMIT = 10;
const VIEWS_KEY = 'Bookmarking-article-views'; // stringified number
const ONBOARDED_KEY = 'Bookmarking-user-is-onboarded'; // stringified boolean

export const initOnboarding = (pageType: StateType['pageType']) => {
  if (localStorage.getItem(ONBOARDED_KEY) === null) {
    localStorage.setItem(ONBOARDED_KEY, 'false');
  }
  if (localStorage.getItem(VIEWS_KEY) === null) {
    localStorage.setItem(VIEWS_KEY, '0');
  }
  if (pageType === 'article') {
    incrementStoredViews();
  }
};

const handleStoredViews = (action = 'get') => {
  const storedViews = localStorage.getItem(VIEWS_KEY);

  try {
    if (!storedViews) {
      throw new Error('storedViews not found');
    }
    const parsedClicks = parseInt(storedViews);
    if (action === 'increment') {
      return localStorage.setItem(VIEWS_KEY, (parsedClicks + 1).toString());
    }
    if (action === 'get') {
      return parseInt(storedViews);
    }
  } catch (ex) {
    console.error(LOG_PREFIX + 'failed to parse stored clicks', ex);
  }
};

//Store article views for onboarding logic.
export const incrementStoredViews = () => handleStoredViews('increment');
export const getStoredViews = () => handleStoredViews('get');

// consider user onboarded if he has visited N articles.
export const userHasReachedLimit = () => {
  if (!isUserOnboarded() && getStoredViews() === VIEW_LIMIT) {
    setUserAsOnboarded();
    return true;
  }
  return false;
};

export const isUserOnboarded = () => {
  const stored = localStorage.getItem(ONBOARDED_KEY);
  try {
    //check for calls before initialization
    if (!stored) throw 'isUserOnboarded not found';
    return JSON.parse(stored);
  } catch (ex) {
    console.error(LOG_PREFIX + ' failed to parse stored clicks', ex);
  }
};

export const setUserAsOnboarded = () => {
  localStorage.setItem(ONBOARDED_KEY, 'true');
};
